import React from 'react';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { PackOverview } from './components/PackOverview';
import { Bonos } from './components/Bonos';
import { UrgencyBlock } from './components/UrgencyBlock';
import { Pricing } from './components/Pricing';
import { KitComparison } from './components/KitComparison';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostTable } from './components/CostTable';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  return <div className="w-full bg-cream font-sans" data-id="element-0" data-mp="23u9tmmkgrbwr">
      <Hero data-id="element-1" data-mp="23ti8k5ohswkq" />
      <main data-id="element-2" data-mp="3ijxokogyjwiu">
        <TrustBar data-id="element-3" data-mp="3ikh8ubu2yx01" />
        <Testimonials data-id="element-4" data-mp="3iiweam7rne26" />
        <PainSection data-id="element-5" data-mp="3ijfunyhrpue3" />
        <PackOverview data-id="element-6" data-mp="3ii4su47vuwpm" />
        <Bonos data-id="element-7" data-mp="3mlax56bfqdtg" />
        <UrgencyBlock data-id="element-8" data-mp="3mkrbpfmkt7ao" />
        <Pricing data-id="element-9" data-mp="3mk83wrqn3zad" />
        <KitComparison data-id="element-10" data-mp="3mjpyp5m02aqb" />
        <MoreTestimonials data-id="element-11" data-mp="3rc9dg5wfbbwp" />
        <Guarantee data-id="element-12" data-mp="3rbzomln47asl" />
        <Faq data-id="element-13" data-mp="3rdkh85pvcjnt" />
        <CostTable data-id="element-14" data-mp="3rd1all5o5hp3" />
        <FinalCta data-id="element-15" data-mp="3relvej26lm9r" />
      </main>
      <Footer data-id="element-16" data-mp="6hpnd64cbd2" />
      <StickyCta data-id="element-17" data-mp="4wxfu7a14id" />
      <PurchaseToast data-id="element-18" data-mp="5ggje8nxyxz" />
      <div className="h-16" aria-hidden="true" data-id="element-19" data-mp="82ovg3doih9" />
    </div>;
}